import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class PTC_Pedidos {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async retornaPedidos(queries = null) {
    let query = 'ptc/retornapedido?';
    const params = [];

    // if (queries === undefined || queries === null || queries === '') {
    //     query = `ptc/retornapedido?`
    // }

    if (queries && queries.nrPedido_PW) {
      params.push(`nrPedido_PW=${queries.nrPedido_PW}`);
    }

    if (queries && queries.codClienteERP) {
      params.push(`codClienteERP=${queries.codClienteERP}`);
    }

    if (queries && queries.razaoSocialCliente) {
      params.push(`razaoSocialCliente=${encodeURIComponent(queries.razaoSocialCliente)}`);
    }

    if (queries && queries.nomeTipoPedido) {
      params.push(`nomeTipoPedido=${queries.nomeTipoPedido}`);
    }

    if (queries && (queries.DataEmissaoDe || queries.DataEmissaoAte)) {
      params.push(`DataEmissaoDe=${queries.DataEmissaoDe}`);
      params.push(`DataEmissaoAte=${queries.DataEmissaoAte}`);
    }

    if (queries && queries.dataEntrega) {
      params.push(`dataEntrega=${queries.dataEntrega}`);
    }

    if (queries && queries.pedidoSituacao) {
      params.push(`pedidoSituacao=${queries.pedidoSituacao}`);
    }

    if (queries && queries.clienteId) {
      params.push(`clienteFinal=${queries.clienteId}`);
    }

    query += params.join('&');

    try {
      const result = await this.api.get(query);
      return result.data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao retornar Pedidos');
    }
  }

  async retornaNotaFiscal(queries = null) {
    const query = '';

    try {
      const result = await this.api.get(query);
      return result.data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao retornar Pedidos');
    }
  }

  async retornaPedidoDetalhe(pedidoid) {
    try {
      const result = await this.api.get(`ptc/retornapedidodetalhe/${pedidoid}`);
      return result.data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao retornar Pedido Detalhe');
    }
  }
}
